import React from "react";
import { withRouter } from "react-router";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled from "styled-components";
import getUrl from "../../functions/getUrl";
import { QuestionAnswer } from "@material-ui/icons";

const SettingButton = styled(Button)`
  height: 40px;
  margin: 1em 1em 2em 1em;
`;

const StyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const IntegrationInfoButton = () => {
  const addIntegrationURL = "/support/integration-definition";

  return (
    <StyledLink to={addIntegrationURL}>
      <SettingButton variant="outlined" color="primary" size="large" startIcon={<QuestionAnswer />}>
        What's an Integration?
      </SettingButton>
    </StyledLink>
  );
};

export default withRouter(IntegrationInfoButton);
